import { useState } from 'react';

import { Button } from '@/shared/ui';

import { Buttons } from './components/Buttons/Buttons';
import { Icons } from './components/Icons/Icons';
import styles from './index.module.scss';

const COMPONENTS_CONFIG = [
  { label: 'Buttons', element: Buttons },
  { label: 'Icons', element: Icons },
];

// http://localhost:3001/playground
export const Playground = () => {
  const [component, setComponent] = useState(COMPONENTS_CONFIG[0]);

  return (
    <div className={styles.container}>
      <div className={styles.navigation}>
        <h2>Components</h2>
        {COMPONENTS_CONFIG.map(({ label, element }, index) => (
          <Button
            key={label + index}
            variant={component.label === label ? 'primary' : 'gray'}
            size="small"
            onClick={() => setComponent({ label, element })}
          >
            {label}
          </Button>
        ))}
      </div>
      <div className={styles.content}>{component.element()}</div>
    </div>
  );
};
